'use client';

import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';
import { isEntirePositionOrder } from '@drift/common';
import { AccountOrder } from '../types';

interface SizeCellProps {
	order: AccountOrder;
}

export function SizeCell({ order }: SizeCellProps) {
	const orderIsFullPosition = isEntirePositionOrder(order.baseAssetAmount);

	if (orderIsFullPosition) {
		return <span>Entire Position</span>;
	}

	return (
		<NumberDisplay
			value={order.baseAssetAmount}
			type="number"
			precision="trade"
			isAccountValueToHide
			trimZeroes
		/>
	);
}
